import { FaWhatsapp } from 'react-icons/fa';

export default function WhatsAppButton() {
  const number = process.env.REACT_APP_WHATSAPP_NUMBER || '917417652434';
  const message = process.env.REACT_APP_WHATSAPP_MESSAGE || 'Hello, I want to join SBS Institute of Coaching';
  const msg = encodeURIComponent(message);
  
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      className="whatsapp-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
